<section class="w-full flex flex-wrap">
    <header class="w-full p-6 border-b border-[#CED3D7] justify-center">
        <p class="font-medium text-sm text-gray-800 text-center">اشتراک‌گذاری</p>
    </header>
    <div class="w-full flex flex-wrap justify-around py-6">
        <div class="w-1/2 flex flex-wrap justify-center" (click)="download()">
            <span class="w-10 h-10 flex items-center justify-center icon arrow-download-filled text-xl bg-[#EDEDED] rounded-full text-center"></span>
            <p class="w-full font-regular text-xs text-gray-800 text-center mt-2">ذخیره در گالری</p>
        </div>
        <div class="w-1/2 flex flex-wrap justify-center" (click)="copyLink()">
            <span class="w-10 h-10 flex items-center justify-center icon link-regular text-gray-800 text-xl bg-[#EDEDED] rounded-full text-center"></span>
            <p class="w-full font-regular text-xs text-gray-800 text-center mt-2">کپی‌کردن لینک</p>
        </div>

    </div>

</section>